module.exports = __webpack_public_path__ + "img/996m2.5e66e818.jpg";